import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetBookingByIdQuery, useGetBookingCancellationByBookingIdQuery } from "../../bookings.service";
import BookingDetails from "../../components/booking-details";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

const BookingDetailsPage = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const backToBookings = appendSearchToPath("/bookings", location.search);
  const { data: booking, isLoading, isError } = useGetBookingByIdQuery(bookingId || "");
  const { data: cancellation } = useGetBookingCancellationByBookingIdQuery(bookingId || "");

  if (isLoading) return <div className="p-6">Loading...</div>;
  if (isError || !booking) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
            <h2 className="text-2xl font-bold text-red-800 mb-4">Booking Not Found</h2>
            <button onClick={() => navigate(backToBookings)} className="px-6 py-3 bg-red-600 text-white rounded-lg">
              Back to Bookings
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <BookingDetails booking={booking} cancellation={cancellation || null} onBack={() => navigate(backToBookings)} />;
};

export default BookingDetailsPage;

